import Base from "./base"

export default class SideMenuManager extends Base {
  constructor(Vue, store) {
    super("side-menu-manager", Vue, store)
    this.closeRouteNames = ["HRoom", "YRoom", "TRoom", "YRoomEntry", "TalkRoom", "TalkRoomEntry"]
  }

  async after(to, from) {
    if (this.closeRouteNames.some(name => name === to.name)) {
      this.store.commit("sideMenu/collapseByLeft", true)
      this.store.commit("sideMenu/collapseByRight", true)
    } else {
      this.store.commit("sideMenu/collapseByLeft", false)
      this.store.commit("sideMenu/collapseByRight", false)
    }
  }
}
